module.exports = __webpack_public_path__ + "linkedin.png?eeb64df8b560830922252f94007c3c26";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/linkedin.png
// module id = 188
// module chunks = 0